/**
 * Velocity Label Sanitizer
 *
 * Shared helper for normalizing component labels to Velocity's validation
 * rules. Velocity's ValidationUtil.isValidArcGISServiceName rejects labels
 * containing dashes, dots, and many special characters for portal/enterprise
 * deployments. Allowed: alphanumeric, underscores, spaces (spaces are
 * normalized to `_` by Velocity).
 *
 * This is the single source of truth used by both the JSON generator (when
 * emitting the importable Velocity configuration) and the documentation
 * builder (when correlating generated Velocity components back to their
 * GeoEvent origin by sanitized label).
 */

export interface SanitizedVelocityLabel {
  sanitized: string;
  wasModified: boolean;
}

/**
 * Sanitizes a label for Velocity validation rules.
 * Replaces spaces with underscores, strips disallowed characters, collapses
 * repeated underscores, and trims leading/trailing underscores. Falls back to
 * `Feed` when the result would be empty.
 */
export function sanitizeVelocityLabel(label: string): SanitizedVelocityLabel {
  const sanitized = label
    .replace(/\s+/g, '_')
    .replace(/[^a-zA-Z0-9_]/g, '')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '');
  return { sanitized: sanitized || 'Feed', wasModified: sanitized !== label };
}
